<tcc-mono-dialog-layout
  [title]="animal.country_code + animal.identification_number"
  [saveText]="'Sluiten'"
  [displayBottomButtons]="true"
  [buttons]="deleteButtons"
  (onSave)="close()"
>
  <tcc-mono-details-table *ngIf="rows.length" [rows]="rows"></tcc-mono-details-table>
  <ng-template #levensnummerTmpl let-value="value">
    <button
      *ngIf="value?.country_code && value?.identification_number"
      type="button"
      class="animal-id-link"
      title="Diergegevens"
      (click)="openAnimalInfo()"
    >
      {{ value.country_code }}{{ value.identification_number }}
      <fa-icon [icon]="['fal', 'circle-info']" class="animal-id-link__icon"></fa-icon>
    </button>
    <ion-text *ngIf="!value?.country_code || !value?.identification_number" color="medium">
      {{ value?.identification_number || '—' }}
    </ion-text>
  </ng-template>
  <div *ngIf="selection" class="mark-color-select">
    <span class="mark-color-select-label">Kleur / Markering</span>
    <div class="mark-color-dots" aria-label="Kies kleur">
      <button
        type="button"
        class="mark-color-dot mark-color-dot-none"
        [class.selected]="animal.selection_mark_color == null"
        (click)="onMarkColorChange(null)"
        title="Geen"
      ></button>
      <button
        *ngFor="let c of usedColors"
        type="button"
        class="mark-color-dot"
        [style.background-color]="getMarkColorHex(c.value)"
        [class.selected]="animal.selection_mark_color === c.value"
        (click)="onMarkColorChange(c.value)"
        [attr.title]="c.name"
      ></button>
    </div>
  </div>
</tcc-mono-dialog-layout>
<ng-template #genderTmpl let-value="value">
  <ion-text
    style="display: flex; flex-direction: row; justify-content: space-between"
  >
    <ion-text [color]="value.gender_id === 1 ? 'male' : 'female'">
      <fa-icon
        [icon]="['fal', value.gender_id === 1 ? 'mars' : 'venus']"
        size="lg"
      ></fa-icon>
    </ion-text>
    <ion-text [color]="value.gender_correct ? 'success' : 'danger'">
      <fa-icon
        [icon]="['fal', value.gender_correct ? 'circle-check' : 'circle-xmark']"
        size="lg"
      ></fa-icon>
    </ion-text>
  </ion-text>
</ng-template>

<ng-template #colorTmpl let-value="value">
  <ion-text
    style="display: flex; flex-direction: row; justify-content: space-between"
  >
    <span>{{ value.color_name }}</span>
    <ion-text [color]="value.color_correct ? 'success' : 'danger'">
      <fa-icon
        [icon]="['fal', value.color_correct ? 'circle-check' : 'circle-xmark']"
        size="lg"
      ></fa-icon>
    </ion-text>
  </ion-text>
</ng-template>

<ng-template #healthyTmpl let-value="value">
  <ion-text [color]="value.is_healthy ? 'success' : 'danger'">
    <fa-icon
      [icon]="['fal', value.is_healthy ? 'circle-check' : 'circle-xmark']"
      size="lg"
    ></fa-icon>
  </ion-text>
</ng-template>

<ng-template #weightTmpl let-value="value">
  <ion-text
    style="display: flex; flex-direction: row; justify-content: space-between"
  >
    <span>{{ value.weight || 0 }} kg</span>
    <ion-text [color]="value.weight_correct ? 'success' : 'danger'">
      <fa-icon
        [icon]="['fal', value.weight_correct ? 'circle-check' : 'circle-xmark']"
        size="lg"
      ></fa-icon>
    </ion-text>
  </ion-text>
</ng-template>
